export default "__VITE_ASSET__DmUfwF$C__"